"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Builder = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _settings = require("./settings.js");
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _sourceTypes = _interopRequireDefault(require("./sourceTypes"));
var _targetTypes = _interopRequireDefault(require("./targetTypes"));
var _cccisdWysiwyg = _interopRequireDefault(require("cccisd-wysiwyg"));
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _AreaPicker = _interopRequireDefault(require("./AreaPicker"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var feedbackPositionOptions = [{
  label: 'Tooltip',
  value: 'tooltip'
}, {
  label: 'Fixed',
  value: 'fixed'
}];
var Builder = exports.Builder = /*#__PURE__*/function (_React$Component) {
  function Builder() {
    var _this;
    _classCallCheck(this, Builder);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Builder, [].concat(args));
    _defineProperty(_this, "renderSource", function (source, sourceField) {
      var element = _sourceTypes["default"][source.type.value];
      var defaultValue = element.defaultLabel || element.name;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: source.label,
        label: "Label",
        isWysiwyg: true,
        wysiwygProps: {
          autofocus: 'end',
          selectAllOnFocus: source.label.value === defaultValue
        }
      }), sourceField);
    });
    _defineProperty(_this, "renderTarget", function (target, targetField) {
      var element = _targetTypes["default"][target.type.value];
      var defaultValue = element.defaultLabel || element.name;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: target.label,
        label: "Label",
        isWysiwyg: true,
        wysiwygProps: {
          autofocus: 'end',
          selectAllOnFocus: target.label.value === defaultValue
        }
      }), targetField);
    });
    _defineProperty(_this, "onChangeFeedbackText", function (key, value) {
      var feedbackTexts = _this.props.fields.feedbackTexts;
      feedbackTexts.onChange(_objectSpread(_objectSpread({}, feedbackTexts.value), {}, _defineProperty({}, key, value)));
    });
    return _this;
  }
  _inherits(Builder, _React$Component);
  return _createClass(Builder, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props$fields = this.props.fields,
        question = _this$props$fields.question,
        description = _this$props$fields.description,
        allowCorrectAnswers = _this$props$fields.allowCorrectAnswers,
        showCorrectStyle = _this$props$fields.showCorrectStyle,
        showFeedback = _this$props$fields.showFeedback,
        feedbackPosition = _this$props$fields.feedbackPosition,
        feedbackTexts = _this$props$fields.feedbackTexts,
        mustDragAllItems = _this$props$fields.mustDragAllItems,
        sources = _this$props$fields.sources,
        sourceTypes = _this$props$fields.sourceTypes,
        isSourcesExpanded = _this$props$fields.isSourcesExpanded,
        targets = _this$props$fields.targets,
        targetTypes = _this$props$fields.targetTypes,
        isTargetsExpanded = _this$props$fields.isTargetsExpanded,
        imageLayout = _this$props$fields.imageLayout,
        sourceArea = _this$props$fields.sourceArea,
        feedbackArea = _this$props$fields.feedbackArea,
        isFeedbackExpanded = _this$props$fields.isFeedbackExpanded,
        isImageLayoutExpanded = _this$props$fields.isImageLayoutExpanded;
      var values = this.props.values;
      var areas = [{
        id: 'sources',
        name: 'Items',
        field: sourceArea
      }].concat(_toConsumableArray(showCorrectStyle.value && feedbackPosition.value === 'fixed' ? [{
        id: 'feedback',
        name: 'Feedback',
        field: feedbackArea
      }] : []), _toConsumableArray(targets.map(function (target) {
        return {
          id: target.id.value,
          name: target.label.value,
          field: target.area
        };
      })));
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: question,
        label: "Question"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
        content: question.value,
        onChange: question.onChange,
        selectAllOnFocus: question.value === _settings.initialValues.question
      })), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: description,
        label: "Description"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
        content: description.value,
        onChange: description.onChange
      })), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        type: "primary",
        title: /*#__PURE__*/_react["default"].createElement("span", null, "Items ", /*#__PURE__*/_react["default"].createElement("span", {
          className: "badge"
        }, sources.length)),
        show: isSourcesExpanded.value,
        handleClick: isSourcesExpanded.onChange,
        isError: (0, _cccisdSurveyCommon.checkForErrors)([sources, sourceTypes])
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.DragDropElements, {
        constant: "SOURCE",
        elements: sources,
        elementTypes: _sourceTypes["default"],
        elementFields: sourceTypes,
        renderElement: this.renderSource,
        dragHint: "Drag items here",
        blockType: "success",
        moveOnTab: true
      })), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        type: "primary",
        title: /*#__PURE__*/_react["default"].createElement("span", null, "Targets ", /*#__PURE__*/_react["default"].createElement("span", {
          className: "badge"
        }, targets.length)),
        show: isTargetsExpanded.value,
        handleClick: isTargetsExpanded.onChange,
        isError: (0, _cccisdSurveyCommon.checkForErrors)([targets, targetTypes])
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          margin: 0
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(mustDragAllItems))), " All items must be dragged into a target")), /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          margin: 0
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(allowCorrectAnswers))), " Targets have correct answers")), allowCorrectAnswers.value && /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          margin: 0
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(showCorrectStyle))), " Show correct/incorrect style"))), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.DragDropElements, {
        constant: "TARGET",
        elements: targets,
        elementTypes: _targetTypes["default"],
        elementFields: targetTypes,
        renderElement: this.renderTarget,
        dragHint: "Drag targets here",
        blockType: "success",
        moveOnTab: true,
        extraProps: {
          values: this.props.values
        }
      })), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        type: "primary",
        title: "Feedback",
        show: isFeedbackExpanded.value,
        handleClick: isFeedbackExpanded.onChange
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: _objectSpread({
          marginTop: 0
        }, !showFeedback.value && {
          marginBottom: 0
        })
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(showFeedback))), " Show feedback")), showFeedback.value && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement("label", null, "Feedback position"), /*#__PURE__*/_react["default"].createElement("div", null, feedbackPositionOptions.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("label", {
          key: option.value,
          className: "radio-inline"
        }, /*#__PURE__*/_react["default"].createElement("input", _extends({
          type: "radio"
        }, (0, _domOnlyProps["default"])(feedbackPosition), {
          value: option.value,
          checked: feedbackPosition.value === option.value
        })), ' ', option.label);
      }))), /*#__PURE__*/_react["default"].createElement("label", null, "Feedback texts"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("table", {
        className: "table table-condensed table-striped table-bordered",
        style: {
          margin: 0
        }
      }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", null, "\xA0"), values.targets.map(function (target) {
        return /*#__PURE__*/_react["default"].createElement("th", {
          key: target.id
        }, (0, _cccisdSurveyCommon.stripTags)(target.label));
      }))), /*#__PURE__*/_react["default"].createElement("tbody", null, values.sources.map(function (source) {
        return /*#__PURE__*/_react["default"].createElement("tr", {
          key: source.id
        }, /*#__PURE__*/_react["default"].createElement("td", null, /*#__PURE__*/_react["default"].createElement("strong", null, (0, _cccisdSurveyCommon.stripTags)(source.label))), values.targets.map(function (target) {
          var key = "".concat(source.id, "_").concat(target.id);
          var value = feedbackTexts.value[key] || '';
          var targetType = values.targetTypes["static"].find(function (item) {
            return item.id === target.id;
          });
          var isCorrect = (targetType.correctItems || []).includes(source.id);
          return /*#__PURE__*/_react["default"].createElement("td", {
            key: target.id,
            className: (0, _classnames2["default"])(_defineProperty(_defineProperty({}, _style["default"].right, allowCorrectAnswers.value && isCorrect), _style["default"].wrong, allowCorrectAnswers.value && !isCorrect)),
            style: {
              width: "".concat(100 / values.targets.length, "%")
            }
          }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
            type: "input",
            content: value,
            onChange: _this2.onChangeFeedbackText.bind(_this2, key)
          }));
        }));
      })))))), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        type: "primary",
        title: "Image layout",
        show: isImageLayoutExpanded.value,
        handleClick: isImageLayoutExpanded.onChange
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.ImagePicker, {
        value: imageLayout.value || 0,
        onChange: imageLayout.onChange,
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-default btn-sm"
        }, "Select image")
      }), imageLayout.value && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        size: "large",
        title: "Mark areas",
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-default btn-sm",
          style: {
            marginLeft: '0.5em'
          }
        }, "Mark areas")
      }, /*#__PURE__*/_react["default"].createElement(_AreaPicker["default"], {
        areas: areas,
        url: imageLayout.value.url
      })), /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-danger btn-sm",
        type: "button",
        style: {
          marginLeft: '0.5em'
        },
        onClick: function onClick() {
          return imageLayout.onChange(null);
        }
      }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)))), imageLayout.value && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].layoutPreview,
        style: {
          backgroundImage: "url(".concat(imageLayout.value.thumbnailLarge, ")"),
          paddingTop: "".concat(imageLayout.value.metadata.height / imageLayout.value.metadata.width * 100, "%")
        }
      }, areas.filter(function (area) {
        return area.field.value;
      }).map(function (area) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: area.id,
          className: _style["default"].areaPlaceholder,
          style: {
            left: "".concat(area.field.value.x, "%"),
            top: "".concat(area.field.value.y, "%"),
            width: "".concat(area.field.value.width, "%"),
            height: "".concat(area.field.value.height, "%")
          }
        }, (0, _cccisdSurveyCommon.stripTags)(area.name));
      }))));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Builder, "propTypes", {
  fields: _propTypes["default"].object,
  values: _propTypes["default"].object
});
var _default = exports["default"] = (0, _cccisdSurveyCommon.builderWrapper)({
  fields: _settings.fields,
  validate: _settings.validate,
  initialValues: _settings.initialValues,
  withTemplate: true,
  withAccommodations: true,
  withAdjustedPlayerSettings: true,
  withBubbleMessages: true,
  withVisibilityConditions: true
})(Builder);